module.exports = __webpack_public_path__ + "img/41.010c7f01.jpg";